import React, { type ReactNode } from 'react';

import { YatLogo } from '@pkg/assets/brand';
import { Thumbnail, type ThumbnailProps } from '@pkg/components';

import { avatarSizePx } from './tokens';
import { AvatarSize } from './types';

import { AvatarWrapper, Badge, BadgeIconWrapper, Interior } from './styles';

export interface AvatarProps
    extends Pick<ThumbnailProps, 'id' | 'title' | 'videoUrl' | 'imageUrl' | 'onError' | 'onLoad'> {
    size?: AvatarSize;
    badge?: boolean;
    children?: ReactNode;
}

export function Avatar({ size = AvatarSize.Medium, badge = false, children, ...thumbnailProps }: AvatarProps) {
    // Simply choosing the largest asset size for now,
    // since we don't have a good way of selecting a
    // size based on DPI.
    const assetSize = avatarSizePx[AvatarSize.Larger];

    const badgeMarkup = badge ? (
        <Badge>
            <BadgeIconWrapper>
                <YatLogo />
            </BadgeIconWrapper>
        </Badge>
    ) : null;

    return (
        <AvatarWrapper $size={size}>
            <Interior>
                <Thumbnail {...thumbnailProps} mashWidth={assetSize} autoPlay />
                {children}
            </Interior>

            {badgeMarkup}
        </AvatarWrapper>
    );
}
